import React, { useState } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, Text2, DataContainer, StatusData, LineContainer, MenuContainer, InnerBox, PagingContainer } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import Paging from 'src/components/App/Paging';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import NoDataFound from '../../NoDataFound/NoDataFound';
import MessageTabForm from '../Forms/MessageTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';

const MessageCard = ({ message = [], page, perPage, setPage, totalCount, fetchMessages, setOpenWhatsappDialog, setWhatsappMessage, setPhoneNumber }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const formatDate = (timestamp) => {
        return dayjs(timestamp).format("D MMM, h:mmA");
    };
    const data = message.map((messageData) => ({
        messageId: messageData?.id,
        message: messageData?.message,
        language: messageData?.language,
        addedDate: formatDate(messageData.createdAt),
        //   addedBy: 'John Doe',
    }));
    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >Add Message</AddAppointment>


            </Container1>
            <Container2>

                <InnerAppointments>

                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Messages Found!"
                                buttonText="Add Message"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />
                        ) : (
                            <>
                                {data.map((item) => (
                                    <BoxContainer key={item.messageId}>
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text2>{item.message}</Text2>
                                                <Texts>{item.language}</Texts>
                                            </DataContainer>

                                        </BoxInner1>
                                        <LineContainer />
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text>{item.addedDate}</Text>
                                                <Texts>Date & Time</Texts>
                                            </DataContainer>
                                            <MenuContainer>
                                                <MenuIcon />
                                            </MenuContainer>
                                        </BoxInner1>
                                    </BoxContainer>
                                ))}
                            </>
                        )}

                    </InnerBox>


                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>
                <DialogBox open={open} onClose={handleClose} >
                    <MessageTabForm onClose={handleClose} fetchMessages={fetchMessages} setOpenWhatsappDialog={setOpenWhatsappDialog}
                        setWhatsappMessage={setWhatsappMessage}
                        setPhoneNumber={setPhoneNumber} />
                </DialogBox>
            </Container2>
        </>
    )
}

export default MessageCard
